import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { catchError, map, of, tap } from 'rxjs';
import { OnboardingService } from '../../shared/services/onboarding/onboarding.service';
import { extractBrandingData } from '../../shared/models/onboarding-config.model';
import { ThemeService } from '../../shared/services/theme/theme.service';
import { BrandingStore } from '../../shared/stores/branding/branding.store';

export interface BrandingData {
  logoUrl: string | null;
  brandColor: string | null;
}

export const brandingResolver: ResolveFn<BrandingData> = () => {
  const onboardingService = inject(OnboardingService);
  const themeService = inject(ThemeService);
  const brandingStore = inject(BrandingStore);

  if (brandingStore.isLoaded()) {
    return of({
      logoUrl: brandingStore.logoUrl(),
      brandColor: brandingStore.brandColor(),
    });
  }

  return onboardingService.getConfig().pipe(
    map((cfg) => extractBrandingData(cfg)),
    tap((branding) => {
      if (branding.brandColor) {
        themeService.applyBrandColor(branding.brandColor);
      }
      brandingStore.setBranding(branding);
    }),
    catchError(() => {
      brandingStore.setBranding({ logoUrl: null, brandColor: null });
      return of({ logoUrl: null, brandColor: null });
    })
  );
};
